__turbopack_context__.v({
  "avatarSlot": "Offers-module__eafQzG__avatarSlot",
  "container": "Offers-module__eafQzG__container",
  "count": "Offers-module__eafQzG__count",
  "extracting": "Offers-module__eafQzG__extracting",
  "extractingText": "Offers-module__eafQzG__extractingText",
  "header": "Offers-module__eafQzG__header",
  "loaderContainer": "Offers-module__eafQzG__loaderContainer",
  "offersList": "Offers-module__eafQzG__offersList",
  "wrapper": "Offers-module__eafQzG__wrapper",
});
